import { useEffect, useMemo, useState } from "react";
import { useNetworkProviderSelector } from "src/ether-utils/context/providerContext";
import TravaPriceFetcher from "src/scoring-fetcher/trava-price-fetcher";

export default function useTravaPrice(network) {
  const [price, setPrice] = useState(null);
  const provider = useNetworkProviderSelector(network);

  const priceFetch = useMemo(() => {
    if (provider) return new TravaPriceFetcher(provider, network);
    return null;
  }, [network, provider]);

  useEffect(async () => {
    if (priceFetch) {
      const _price = await priceFetch.getTravaPrice();
      setPrice(_price);
    }
  }, [priceFetch]);

  return price;
}
